/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { flexibleBlockCardStyle } from '../styledOld';
export var withFlexibleUIBlockCardStyleOld = function withFlexibleUIBlockCardStyleOld(FlexibleBlockCardView) {
  return function (props) {
    return (
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      jsx("div", {
        css: flexibleBlockCardStyle
      }, jsx(FlexibleBlockCardView, props))
    );
  };
};